import React from 'react';
import { SpinLoader } from '../react-loader/spin-loader/SpinLoader';
import { SpinLoaderTypes } from '../react-loader/spin-loader/SpinLoader.types';

export function PageLoader() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100%',
    }}>
      <SpinLoader type={SpinLoaderTypes.large} color="var(--ce-text-primary)" />
    </div>
  );
}
